import { useLocation } from 'react-router-dom';
import { siteInfo, categories, articles } from '@/mocks/siteData';

export default function SchemaOrg() {
  const location = useLocation();
  const baseUrl = siteInfo.url;

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: baseUrl,
    description: siteInfo.description,
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@bie-niao-challenge.cn',
      contactType: 'customer service',
    },
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: baseUrl,
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${baseUrl}/search?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const renderBreadcrumbSchema = () => {
    const pathParts = location.pathname.split('/').filter(Boolean);
    const items = [{ '@type': 'ListItem', position: 1, name: '首页', item: baseUrl }];

    if (pathParts[0] === 'category' && pathParts[1]) {
      const cat = categories.find((c) => c.slug === pathParts[1]);
      items.push({
        '@type': 'ListItem',
        position: 2,
        name: cat?.name || pathParts[1],
        item: `${baseUrl}/category/${pathParts[1]}`,
      });
    }

    if (pathParts[0] === 'article' && pathParts[1]) {
      items.push({
        '@type': 'ListItem',
        position: 2,
        name: '文章',
        item: `${baseUrl}/article/${pathParts[1]}`,
      });
    }

    if (pathParts[0] === 'about') {
      items.push({
        '@type': 'ListItem',
        position: 2,
        name: '关于我们',
        item: `${baseUrl}/about`,
      });
    }

    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: items,
    };
  };

  const renderArticleSchema = () => {
    if (!location.pathname.startsWith('/article/')) return null;
    const slug = location.pathname.split('/article/')[1];
    const article = articles.find((a) => a.slug === slug);
    if (!article) return null;
    const cat = categories.find((c) => c.slug === article.category);

    return {
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: article.title,
      description: article.excerpt,
      datePublished: article.publishedAt,
      author: { '@type': 'Organization', name: siteInfo.name },
      publisher: { '@type': 'Organization', name: siteInfo.name },
      articleSection: cat?.name || '',
      url: `${baseUrl}/article/${article.slug}`,
    };
  };

  const renderWebPageSchema = () => {
    return {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: siteInfo.title,
      description: siteInfo.description,
      url: `${baseUrl}${location.pathname}`,
      isPartOf: { '@type': 'WebSite', name: siteInfo.name, url: baseUrl },
    };
  };

  const allSchemas = [
    organizationSchema,
    websiteSchema,
    renderWebPageSchema(),
    renderBreadcrumbSchema(),
    renderArticleSchema(),
  ].filter(Boolean);

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(allSchemas, null, 2) }}
    />
  );
}